import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { PrazoPagamento } from '../../../core/models/prazos-pagamento/prazo-pagamento';

@Component({
  selector: 'app-prazo-pagamento-select',
  templateUrl: './prazo-pagamento-select.component.html',
  styleUrls: ['./prazo-pagamento-select.component.scss'],
  standalone: false
})
export class PrazoPagamentoSelectComponent implements OnChanges {
  @Input() prazosIniciais: PrazoPagamento[] = [];
  @Input() prazosEspeciais: PrazoPagamento[] = [];
  @Input() prazoSelecionado: PrazoPagamento = null;
  @Input() desabilitado: boolean = false;
  @Input() invalido: boolean = false;
  @Input() ocultarTitulosIniciais: boolean = false;
  @Output() prazoChange = new EventEmitter<number>();

  termo: string = '';
  aberto: boolean = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.prazoSelecionado || changes.prazosIniciais || changes.prazosEspeciais) {
      this.sincronizarTextoSelecionado();
    }
  }

  abrir(): void {
    if (this.desabilitado) {
      return;
    }

    this.limparTextoAoAbrir();
    this.aberto = true;
  }

  alternar(): void {
    if (this.desabilitado) {
      return;
    }

    const vaiAbrir = !this.aberto;
    if (vaiAbrir) {
      this.limparTextoAoAbrir();
    }

    this.aberto = vaiAbrir;
  }

  fecharComAtraso(): void {
    setTimeout(() => {
      this.aberto = false;
      this.sincronizarTextoSelecionado();
    }, 160);
  }

  limpar(): void {
    this.termo = '';
    this.aberto = true;
    this.prazoChange.emit(0);
  }

  selecionar(prazo: PrazoPagamento): void {
    if (this.desabilitado || prazo == null) {
      return;
    }

    this.termo = prazo.descricao || '';
    this.aberto = false;
    this.prazoChange.emit(prazo.idprazopagamento);
  }

  prazosIniciaisFiltrados(): PrazoPagamento[] {
    return this.filtrar(this.prazosIniciais);
  }

  prazosEspeciaisFiltrados(): PrazoPagamento[] {
    return this.filtrar(this.prazosEspeciais);
  }

  temResultados(): boolean {
    return this.prazosIniciaisFiltrados().length > 0 || this.prazosEspeciaisFiltrados().length > 0;
  }

  private filtrar(prazos: PrazoPagamento[]): PrazoPagamento[] {
    const lista = prazos || [];
    const filtro = this.normalizar(this.termo);

    if (!filtro) {
      return lista;
    }

    return lista.filter(prazo => this.normalizar(prazo != null ? prazo.descricao : '').includes(filtro));
  }

  private sincronizarTextoSelecionado(): void {
    this.termo = this.prazoSelecionado != null ? (this.prazoSelecionado.descricao || '') : '';
  }

  private limparTextoAoAbrir(): void {
    if (this.prazoSelecionado != null && this.termo === (this.prazoSelecionado.descricao || '')) {
      this.termo = '';
    }
  }

  private normalizar(valor: string): string {
    return (valor || '')
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();
  }
}
